import HeroBG from "../../Components/Style/HeroBG";
import LiquidGlass from "../../Components/Style/LiquidGlass";
import ContainerSignUp from "./Components/ContainerSignUp";
import ContainerSignUpInfo from "./Components/ContainerSignUpInfo";
import ContainerSignUpPhone from "./Components/ContainerSignUpPhone";
import { useLayoutEffect, useState } from "react";

export default function SignUp() {
  const [signupData, setSignupData] = useState({
    email: "",
    password: "",
    password_again: "",
    phone_number: "",
    fn: "",
    ln: "",
    referral_code: "",
  });
  const [step, setStep] = useState(1);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (step === 1) {
    return (
      <div className="relative flex justify-center items-center min-h-dvh bg-zi-bg1-light dark:bg-zi-bg1-dark p-4">
        <div className="absolute inset-0 z-0 transition-none">
          <HeroBG />
        </div>
        <LiquidGlass tag="div" rounded="3xl" className="rounded-3xl max-w-sm w-full flex z-10" childrenClassName="w-full">
          <ContainerSignUp
            signupData={signupData}
            setSignupData={setSignupData}
            setStep={setStep}
            text="ایجاد حساب کاربری"
            subtext="مرحله ۱ از ۳: آدرس ایمیل و کد معرف"
          />
        </LiquidGlass>
        <span className="hidden absolute w-full h-[1px] bottom-16 bg-zi-gradient-divider"></span>
      </div>
    );
  }
  if (step === 2) {
    return (
      <div className="relative flex justify-center items-center min-h-dvh bg-zi-bg1-light dark:bg-zi-bg1-dark p-4">
        <div className="absolute inset-0 z-0 transition-none">
          <HeroBG />
        </div>
        <LiquidGlass tag="div" rounded="3xl" className="rounded-3xl max-w-sm w-full flex z-10" childrenClassName="w-full">
          <ContainerSignUpPhone
            signupData={signupData}
            setSignupData={setSignupData}
            setStep={setStep}
            text="ایجاد حساب کاربری"
            subtext="مرحله ۲ از ۳: ایجاد رمز عبور"
          />
        </LiquidGlass>
        <span className="hidden absolute w-full h-[1px] bottom-16 bg-zi-gradient-divider"></span>
      </div>
    );
  }
  if (step === 3) {
    return (
      <div className="relative flex justify-center items-center min-h-dvh bg-zi-bg1-light dark:bg-zi-bg1-dark p-4">
        <div className="absolute inset-0 z-0 transition-none">
          <HeroBG />
        </div>
        <LiquidGlass tag="div" rounded="3xl" className="rounded-3xl max-w-sm w-full flex z-10" childrenClassName="w-full">
          <ContainerSignUpInfo
            signupData={signupData}
            setSignupData={setSignupData}
            setStep={setStep}
            text="ایجاد حساب کاربری"
            subtext="مرحله ۳ از ۳: شماره همراه و اطلاعات شخصی"
          />
        </LiquidGlass>
        <span className="hidden absolute w-full h-[1px] bottom-16 bg-zi-gradient-divider"></span>
      </div>
    );
  }
}
